<template>
  <div dir="rtl">
    <div
      v-show="loading"
      style="width: 100%;height: 100%;position: fixed;top: 0px;left: 0px;z-index: 999;background: rgba(0,0,0,.4);"
    >
      <img
        src="../../assets/images/spinner.gif"
        width="100"
        style="position: absolute;top: 50%;left: 50%;width:100px"
      />
    </div>
    <v-container>
      <v-layout wrap="">
        <v-flex xs12 sm6 md2>
          <v-text-field
            @keyup.enter="search_client_by_code"
            v-model="searchClientCode"
            label="كودالعميل"
          ></v-text-field>
        </v-flex>
        <v-flex xs12 sm6 md4>
          <v-autocomplete
            v-model="select_client"
            :hint="
              `${
                select_client.mandob_sales
                  ? select_client.mandob_sales.name
                  : ''
              }- ${select_client.mohafza ? select_client.mohafza.name : ''}- ${
                select_client.city ? select_client.city.name : ''
              }- ${select_client.region ? select_client.region.name : ''}- ${
                select_client.branch ? select_client.branch.name : ''
              }`
            "
            :items="clients"
            item-text="name"
            item-value="id"
            label="أختر العميل"
            persistent-hint
            return-object
            single-line
            @change="get_all_info"
          >
            <template v-slot:append-outer>
              <v-slide-x-reverse-transition mode="out-in">
              </v-slide-x-reverse-transition>
            </template>
          </v-autocomplete>
        </v-flex>
        <v-flex xs12 sm6 md2>
          <v-text-field
            v-model="the_money"
            type="number"
            label="خصم من المديونية "
          ></v-text-field>
        </v-flex>
        <v-flex xs12 sm6 md2>
          <v-text-field
            disabled
            v-model="madionia"
            label=" المديونية "
          ></v-text-field>
        </v-flex>
        <v-flex xs12 sm6 md2>
          <v-dialog
            ref="dialog2"
            v-model="modal2"
            :return-value.sync="date2"
            persistent
            lazy
            full-width
            width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="date2"
                label=" التاريخ اليدوي"
                readonly
                outline
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker v-model="date2" scrollable>
              <v-spacer></v-spacer>
              <v-btn flat color="primary" @click="modal2 = false">Cancel</v-btn>
              <v-btn flat color="primary" @click="$refs.dialog2.save(date2)"
                >OK</v-btn
              >
            </v-date-picker>
          </v-dialog>
        </v-flex>

        <v-flex xs12 sm6 md4>
          <v-textarea
            v-model="madionia_client_table.note"
            label=" ملاحظات  "
          ></v-textarea>
        </v-flex>

        <v-flex xs12 sm6 md2>
          <v-btn @click="add_khasm_madionia">أضف خصم</v-btn>
        </v-flex>
      </v-layout>
      <div v-if="fatworas.length > 0">
        فواتير المبيعات الغير مسددة
        <v-data-table
          :headers="headers"
          :items="fatworas"
          class="elevation-1"
          v-if="fatworas.length > 0"
          :rows-per-page-items="rowsPerPageItems"
        >
          <template slot="items" slot-scope="props">
            <td>{{ props.item.code }}</td>
            <td class="text-xs-right">{{ props.item.price_after }}</td>
            <td class="text-xs-right">{{ props.item.remain }}</td>
            <td class="text-xs-right">{{ props.item.sdad_status }}</td>
            <td class="text-xs-right">{{ props.item.sdad_type_name }}</td>
            <td class="text-xs-right">{{ props.item.taslim_date }}</td>
            <td class="text-xs-right">{{ props.item.madionia_now }}</td>
            <td class="text-xs-right">
              <v-text-field
                v-model="props.item.money"
                type="number"
                label="خصم من فاتورة"
              ></v-text-field>
            </td>
            <td class="text-xs-right">
              <v-btn primary @click="add_khasm(props.item)">أخصم</v-btn>
            </td>
          </template>
        </v-data-table>
      </div>
      <div v-else>لا يوجد فواتير غير مسددة</div>
      <br />
      <hr />
      <hr />
      <br />

      <div v-if="khasm_fatworas.length > 0">
        فواتير الخصم السابقة
        <v-data-table
          :headers="headers2"
          :items="khasm_fatworas"
          class="elevation-1"
          v-if="khasm_fatworas.length > 0"
          :rows-per-page-items="rowsPerPageItems"
        >
          <template slot="items" slot-scope="props">
            <td>{{ props.item.money }}</td>
            <td class="text-xs-right">{{ props.item.note }}</td>
            <td class="text-xs-right">
              {{
                props.item.type == "global"
                  ? "خصم من المديونية"
                  : "خصم من الفاتورة"
              }}
            </td>
            <td class="text-xs-right">
              {{
                props.item.fatwora
                  ? props.item.fatwora.code
                  : "لا يوجد فاتورة معينة"
              }}
            </td>
            <td class="text-xs-right">
              {{ props.item.user ? props.item.user.name : "" }}
            </td>
            <td class="text-xs-right">{{ props.item.created_at }}</td>
            <td class="text-xs-right">
              <v-btn
                v-if="permissions.delete_all == 1 || user.type == 1"
                @click="delete_khasm(props.item)"
                >حذف</v-btn
              >
            </td>
          </template>
        </v-data-table>
      </div>
      <div v-else>لا يوجد فواتير خصم سابقة</div>
    </v-container>
  </div>
</template>

<script>
import Vue from "vue";
import {
  clients,
  search_client_by_code,
  madionia_client,
  fatworas_client_no_sadad,
  khazinas,
  khazina,
  khazna_fatworas,
  add_client_khasm,
  add_khasm_madionia,
  get_all_client_info,
  delete_client_khasm,
  log_me
} from "../config/apiRoute.js";
import { setTimeout } from "timers";
export default {
  data: () => ({
    user: [],
    permissions: [],
    rowsPerPageItems: [400, 800],
    add_dialog: false,
    edit_dialog: false,
    headers: [
      {
        text: " الكود",
        align: "right",
        value: "name",
        sortable: false
      },
      { text: " السعر", value: "address", sortable: false, align: "right" },
      { text: " المتبقي", value: "address", sortable: false, align: "right" },
      { text: " حالة السداد", value: "rasid", sortable: false, align: "right" },
      { text: " نوع السداد", value: "rasid", sortable: false, align: "right" },
      {
        text: "تاريخ التسليم",
        value: "control",
        sortable: false,
        align: "center"
      },
      {
        text: "المديونية وقتها ",
        value: "control",
        sortable: false,
        align: "center"
      },
      {
        text: " مبلغ الخصم ",
        value: "control",
        sortable: false,
        align: "center"
      },
      {
        text: " تنفيذ الخصم ",
        value: "control",
        sortable: false,
        align: "center"
      }
    ],
    headers2: [
      {
        text: " المبلغ",
        align: "right",
        value: "name",
        sortable: false
      },
      { text: " الملاحظات", value: "address", sortable: false, align: "right" },
      { text: " نوع الخصم", value: "address", sortable: false, align: "right" },
      {
        text: "كود الفاتورة ",
        value: "rasid",
        sortable: false,
        align: "right"
      },
      { text: "اسم المستخدم", value: "rasid", sortable: false, align: "right" },
      { text: "التاريخ ", value: "control", sortable: false, align: "center" },
      { text: "جذف ", value: "control", sortable: false, align: "center" }
    ],
    select_client: { id: "" },
    select_khazna: { id: "" },
    search: "",
    comment: "",
    loading: true,
    menu2: false,
    dialog2: false,
    modal2: false,
    date2: new Date().toISOString().substr(0, 10),
    khazina_fatworas: [],
    clients: [],
    fatworas: [],
    khazinas: [],
    all_client_fatworas: [],
    all_client_sadads: [],
    theKhazna: {},
    money: "",
    searchClientCode: "",
    madionia_sabqa: "",
    madionia_sabqa_of_madionia: "",
    madionia: "",
    khasm_fatworas: [],

    // madionia_client_table: {
    //   madionia_before: "",
    //   cost_or_money: "",
    //   madionia_after: "",
    //   emp_name: "",
    //   type_of_operation: "",
    //   code_of_operation: "",
    //   client_id: "",
    //   emp_id: "",
    //   created_at: ""
    // },
    madionia_client_table: {
      money: "",
      note: "",
      client_id: "",
      user_id: "",
      created_at: ""
    },
    fatwora_client: {
      id: "",
      remain: "",
      created_at: ""
    },
    the_money: ""
  }),

  computed: {
    // mycode() {
    //   if (this.khazina_fatworas.length > 0) {
    //     return (this.code =
    //       parseInt(
    //         this.khazina_fatworas[this.khazina_fatworas.length - 1].code
    //       ) + 1);
    //   } else {
    //     return (this.code = 1000);
    //   }
    // }
  },

  watch: {
    //    dialog (val) {
    //   val || this.close()
    // }
  },

  created() {
    this.user = JSON.parse(localStorage.getItem("user"));
    this.permissions = JSON.parse(localStorage.getItem("permission"));
    this.initialize();
  },

  methods: {
    initialize() {
      clients().then(response => {
        this.clients = response.data;
        this.loading = false;
      });

      khazna_fatworas().then(response => {
        this.khazina_fatworas = response.data;
      });
    },

    search_client_by_code() {
      search_client_by_code(this.searchClientCode).then(response => {
        this.select_client = response.data;
        this.get_all_info();
      });
    },
    get_all_info() {
      this.fatworas = [];
      this.khazinas = [];
      this.madionia = 0;
      this.khasm_fatworas = [];
      this.madionia_sabqa = "";
      this.searchClientCode = this.select_client.code;
      this.loading = true;
      get_all_client_info(this.select_client.id).then(res => {
        this.khazinas = res.data.khazinas;
        this.fatworas = res.data.fatworas_no_sadad;
        this.madionia = res.data.madionia;
        this.khasm_fatworas = res.data.khasm_fatworas;
        this.loading = false;
      });
      // khazinas(this.select_client.branch_id).then(response => {
      //   this.khazinas = response.data;
      // });
      // this.searchClientCode = this.select_client.code;
      // this.fatworas = [];
      // this.madionia_sabqa = "";
      // this.loading = true;
      // fatworas_client_no_sadad(this.select_client.id).then(response => {
      //   this.fatworas = response.data;
      //   this.loading = false;
      // });
      // madionia_client(this.select_client.id).then(response => {
      //   this.madionia_sabqa =
      //     parseFloat(response.data.madionia) +
      //     (response.data.client.rasid_efttahi != ""
      //       ? parseFloat(response.data.client.rasid_efttahi)
      //       : 0);
      //   this.madionia_sabqa_of_madionia =
      //     response.data.madionia != 0
      //       ? parseFloat(response.data.madionia)
      //       : 0;
      // });
    },

    get_khazina() {
      khazina(this.select_khazna.id).then(response => {
        this.theKhazna = response.data;
      });
    },

    close() {
      this.add_dialog = false;
      this.edit_dialog = false;
      //   setTimeout(() => {
      //     this.editedItem = Object.assign({}, this.defaultItem)
      //     this.editedIndex = -1
      //   }, 300)
    },

    add_khasm(item) {
      let myUser = JSON.parse(localStorage.getItem("user"));
      this.fatwora_client.id = item.id;
      this.fatwora_client.remain = item.money;
      this.fatwora_client.emp = myUser.name;
      this.fatwora_client.created_at = this.date2;
      let client_fatworas_ = JSON.stringify(this.fatwora_client);

      // this.madionia_client_table.madionia_before = this.madionia_sabqa_of_madionia;
      // this.madionia_client_table.cost_or_money = item.money;
      // this.madionia_client_table.madionia_after =
      //   parseFloat(this.madionia_sabqa_of_madionia) - parseFloat(item.money);
      // this.madionia_client_table.emp_name = myUser.name;
      // this.madionia_client_table.type_of_operation = "khasm";
      // this.madionia_client_table.code_of_operation = item.code;
      // this.madionia_client_table.client_id = this.select_client.id;
      // this.madionia_client_table.emp_id = myUser.id;
      // this.madionia_client_table.created_at = this.date2;

      this.madionia_client_table.money = item.money;
      this.madionia_client_table.user_id = myUser.id;
      this.madionia_client_table.client_id = this.select_client.id;
      this.madionia_client_table.created_at = this.date2;

      let madionia_client_ = JSON.stringify(this.madionia_client_table);

      this.do_Khasm(madionia_client_, client_fatworas_);
    },
    do_Khasm(madionia_client_, client_fatworas_) {
      this.loading = true;
      var frmData = new FormData();
      frmData.append("madionia_client_table", madionia_client_);
      frmData.append("client_fatworas_table", client_fatworas_);
      add_client_khasm(frmData).then(response => {
        this.loading = false;
        this.$router.go(0);
      });
    },
    add_khasm_madionia() {
      this.loading = true;

      let myUser = JSON.parse(localStorage.getItem("user"));
      this.madionia_client_table.money = this.the_money;
      this.madionia_client_table.user_id = myUser.id;
      this.madionia_client_table.client_id = this.select_client.id;
      this.madionia_client_table.created_at = this.date2;
      let madionia_client_ = JSON.stringify(this.madionia_client_table);
      var frmData = new FormData();
      frmData.append("madionia_client_table", madionia_client_);
      add_khasm_madionia(frmData).then(response => {
        this.loading = false;
        if (response.data == "false" || response.data == false) {
          alert("يجب ادخال قيمة الخصم");
          return;
        }
        let myUser = JSON.parse(localStorage.getItem("user"));
        var frmData3 = new FormData();
        frmData3.append("title", "خصم عميل");
        frmData3.append(
          "body",
          " -تم خصم المديونية لعميل بكود -" +
            this.select_client.code +
            "- بواسطة -" +
            myUser.name +
            "- قيمتها -" +
            this.the_money +
            " -"
        );
        frmData3.append("type", "client_khasm");
        frmData3.append("user_id", myUser.id);
        log_me(frmData3).then(response => {
          if (response.data == true) {
            let mytitle = " خصم عميل";
            let mybody =
              " - تم خصم المديونية لعميل بكود -" +
              this.select_client.code +
              "-واسمه -" +
              this.select_client.name +
              "-قيمتها -" +
              this.the_money +
              "- بواسطة -" +
              myUser.name;
            this.$toastr.warning(mybody, mytitle, {
              closeButton: true,
              progressBar: true,
              positionClass: "toast-bottom-left",
              preventDuplicates: false,
              timeOut: "25000"
            });
          }
        });
        setTimeout(() => {
          this.$router.go(0);
        }, 3000);
      });
    },

    delete_khasm(item) {
      this.$swal({
        title: "هل تريد الأستمرار",
        text: "سيتم الحذف نهائيا ولا يمكن الرجوع",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "نعم !",
        cancelButtonText: "لا"
      }).then(result => {
        if (result.value) {
          const index = this.khasm_fatworas.indexOf(item);

          this.loading = true;

          delete_client_khasm(item.id).then(response => {
            this.loading = false;
            this.khasm_fatworas.splice(index, 1);
            this.close();
            this.$router.go(0);
          });
        }
      });
    },

    push_client_sadad(sadad) {
      this.all_client_sadads.push(sadad);
    }
  }
};
</script>

<style scope>
.v-datatable__actions__range-controls {
  display: none;
}
.v-dialog.v-dialog--active {
  direction: rtl;
}
.v-label.v-label--active {
  right: 0px !important;
}
.v-label.theme--light {
  right: 0px !important;
}
</style>
